<!-- Notificaciones clásicas -->
<ng-container *ngFor="let notification of generalService.notifications">
  <desy-notification
    [id]="notification.id"
    [classes]="notification.classes"
    [(isOpen)]="notification.open"
    [type]="notification.type"
    [isDismissible]="notification.dismissible">
    <desy-title>{{ notification.title.text }}</desy-title>
  </desy-notification>
</ng-container>

<!-- Notificaciones V2 (HTML) -->
<!-- Notificaciones V2 (HTML) -->
<ng-container *ngFor="let notification of generalService.notificationsV2">
  <desy-notification
    [id]="notification.id || ''"
    [classes]="'c-notification c-notification--alert fixed-notification'"
    [(isOpen)]="notification.open"
    [type]="notification.type"
    [isDismissible]="notification.dismissible"
    [headingLevel]="notification.headingLevel ?? 3">

    <desy-title>{{ notification.titleNotification?.text }}</desy-title>

    <desy-description [classes]="notification.description?.classes || ''">
      <span *ngIf="notification.description?.html" [innerHTML]="notification.description?.html"></span>
    </desy-description>
    
    <desy-content [classes]="notification.content?.classes || ''">
      <span *ngIf="notification.content?.html" [innerHTML]="notification.content?.html"></span>
    </desy-content>

  </desy-notification>
</ng-container>

